<script>
export default {
    name: 'ContentGoodToKnowBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="good-to-know-block">
        <svg class="good-to-know-block__icon" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4393 31.6724C19.4393 25.9154 24.5234 23.8967 27.0654 23.8967V21.1304C27.4393 21.1304 27.4393 21.1304 24.4486 21.1304C22.4299 21.1304 20.7103 19.0369 20.7103 17.3173C20.7103 16.4949 21.0841 16.1958 21.8318 16.1958C22.5794 16.1958 25.9439 16.1958 28.3364 16.1958C30.4299 16.1958 32 18.364 32 19.336C32 20.5322 32 22.9996 32 28.0089C32 32.5696 26.3925 38.7752 20.1122 38.7752C13.8318 38.7752 8 33.2425 8 28.3827C8 24.3753 8 18.9871 8 16.7939" stroke="currentColor"/>
            <rect x="8" y="14.5508" width="4.63551" height="8.37383" rx="2.31776" stroke="currentColor"/>
            <rect x="12.6353" y="12.0083" width="4.63551" height="10.9159" rx="2.31776" stroke="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7475 1.49023C23.15 1.49023 21.855 2.78526 21.855 4.38276V16.196H22.855V4.38276C22.855 3.33755 23.7023 2.49023 24.7475 2.49023C25.7927 2.49023 26.64 3.33755 26.64 4.38276V16.196H27.64V4.38276C27.64 2.78526 26.345 1.49023 24.7475 1.49023Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8131 10.4624C18.133 10.4624 16.771 11.8244 16.771 13.5045V20.383C16.771 22.063 18.133 23.425 19.8131 23.425C21.3914 23.425 22.689 22.223 22.8404 20.6844C22.4769 20.4779 22.1441 20.2102 21.8551 19.9039V20.383C21.8551 21.5108 20.9408 22.425 19.8131 22.425C18.6853 22.425 17.771 21.5108 17.771 20.383V13.5045C17.771 12.3767 18.6853 11.4624 19.8131 11.4624C20.9408 11.4624 21.8551 12.3767 21.8551 13.5045V16.1959H22.8551V13.5045C22.8551 11.8244 21.4931 10.4624 19.8131 10.4624Z" fill="currentColor"/>
        </svg>
        <div class="good-to-know-block__text richtext" v-html="data.text"></div>
    </div>
</template>

<style lang="scss">
.good-to-know-block {
    display: flex;
    align-items: flex-start;
    gap: 1.8rem;
    margin-top: 5.6rem;
    margin-bottom: 5.6rem;
    color: $color-primary-alt;

    @include breakpoint('xs') {
        gap: 1rem;
    }
}

.good-to-know-block__icon {
    flex: 0 0 4rem;

    @include breakpoint('xs') {
        flex: 0 0 3.2rem;
    }
}

.good-to-know-block__text {
    font-size: 2.4rem;
    letter-spacing: 0.032rem;
    line-height: 1.5;
    margin: 0;
}

</style>
